
// Simple Web Audio API Synthesizer for "Calm" Sound Design

let audioCtx: AudioContext | null = null;

export const initAudio = async () => {
    if (!audioCtx) {
        audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    if (audioCtx.state === 'suspended') {
        await audioCtx.resume();
    }
    return audioCtx;
};

export const playChime = async () => {
    try {
        await initAudio();
        if (!audioCtx) return;

        const oscillator = audioCtx.createOscillator();
        const gainNode = audioCtx.createGain();

        oscillator.type = 'sine';
        // High, ethereal pitch
        oscillator.frequency.setValueAtTime(880, audioCtx.currentTime); // A5
        oscillator.frequency.exponentialRampToValueAtTime(1760, audioCtx.currentTime + 0.1); // A6

        // Gentle envelope
        gainNode.gain.setValueAtTime(0.01, audioCtx.currentTime);
        gainNode.gain.linearRampToValueAtTime(0.05, audioCtx.currentTime + 0.05); // Very quiet
        gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 1.5);

        oscillator.connect(gainNode);
        gainNode.connect(audioCtx.destination);

        oscillator.start();
        oscillator.stop(audioCtx.currentTime + 1.5);
    } catch (e) {
        // Silent fail if audio disallowed
    }
};

export const playWhisper = async () => {
    try {
        await initAudio();
        if (!audioCtx) return;

        // White noise buffer for "whisper" texture
        const bufferSize = audioCtx.sampleRate * 0.5; // 0.5 seconds
        const buffer = audioCtx.createBuffer(1, bufferSize, audioCtx.sampleRate);
        const data = buffer.getChannelData(0);

        for (let i = 0; i < bufferSize; i++) {
            data[i] = Math.random() * 2 - 1;
        }

        const noise = audioCtx.createBufferSource();
        noise.buffer = buffer;

        // Filter to make it soft (Lowpass)
        const filter = audioCtx.createBiquadFilter();
        filter.type = 'lowpass';
        filter.frequency.value = 400;

        const gainNode = audioCtx.createGain();
        gainNode.gain.setValueAtTime(0.05, audioCtx.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.4);

        noise.connect(filter);
        filter.connect(gainNode);
        gainNode.connect(audioCtx.destination);

        noise.start();
    } catch (e) {
        // Silent fail
    }
};

export const playSparkle = async () => {
    try {
        await initAudio();
        if (!audioCtx) return;

        const oscillator = audioCtx.createOscillator();
        const gainNode = audioCtx.createGain();

        oscillator.type = 'sine';
        // Quick upward sweep for "magic" feel
        oscillator.frequency.setValueAtTime(1200, audioCtx.currentTime);
        oscillator.frequency.exponentialRampToValueAtTime(2400, audioCtx.currentTime + 0.1);

        gainNode.gain.setValueAtTime(0, audioCtx.currentTime);
        gainNode.gain.linearRampToValueAtTime(0.04, audioCtx.currentTime + 0.05);
        gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.3);

        oscillator.connect(gainNode);
        gainNode.connect(audioCtx.destination);

        oscillator.start();
        oscillator.stop(audioCtx.currentTime + 0.3);
    } catch (e) {}
};

export const playMysticChord = async () => {
    try {
        await initAudio();
        if (!audioCtx) return;
        
        // C Major 7th chord spread out
        const frequencies = [261.63, 329.63, 392.00, 493.88]; 

        frequencies.forEach((freq, i) => {
            const osc = audioCtx!.createOscillator();
            const gain = audioCtx!.createGain();
            
            osc.type = 'triangle';
            osc.frequency.value = freq;
            
            // Staggered entry
            const startTime = audioCtx!.currentTime + (i * 0.1);
            
            gain.gain.setValueAtTime(0, startTime);
            gain.gain.linearRampToValueAtTime(0.02, startTime + 0.5);
            gain.gain.exponentialRampToValueAtTime(0.001, startTime + 4);

            osc.connect(gain);
            gain.connect(audioCtx!.destination);
            
            osc.start(startTime);
            osc.stop(startTime + 4);
        });

    } catch (e) {
        // Silent fail
    }
};
